import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getBranch } from './get-branch';

/** `PUT /client/:cid/branches/:id/three-pl {partner_id}`: one of the client's `partners`. */
export const editBranchThreePl = async (branch_id: string, partner_id: string): Promise<any> => {
  await lpRequest('PUT', clientPath(`/branches/${branch_id}/three-pl`), { body: { partner_id } });

  return getBranch(branch_id);
};
